import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
// mui icons
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Button, TextField } from '@mui/material';
import { CursoState } from '../../../store/slices/curso';
import { ModuloState } from '../../../store/slices/modulo';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { crearEjercicio } from '../../../store/slices/ejercicio';

type Props = {
  curso: CursoState,
  modulo: ModuloState,
  tipo: string
  setOpen: any
}

const FormularioCrearSM = ({curso, modulo, tipo, setOpen}: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const [letra, setLetra] = useState('');
  const [enunciado, setEnunciado] = useState('');

  const [alternativas, setAlternativas] = useState([
    { alternativa: '', letra: 'A', estado: false },
    { alternativa: '', letra: 'B', estado: false },
    { alternativa: '', letra: 'C', estado: false },
    { alternativa: '', letra: 'D', estado: false },
  ]);

  useEffect(() => {
    setAlternativas(alternativas.map(item => item.letra === letra ? {...item, estado: true} : {...item, estado: false}))
  }, [letra, alternativas])

  const handleCrearEjercicio = () => {

    const letras = []

    for (let k = 0; k < alternativas.length; k++) {
      const element = alternativas[k];
      if (element.alternativa !== '') {
        letras.push(true)
      }
    }

    if (enunciado !== '' && letras.filter(Boolean).length === 4 && letra !== '') {
      const nuevoEjercicio = {
        cid: curso.cid,
        mid: modulo.mid,
        numero: 1, 
        tipo: tipo, 
        enunciado: enunciado, 
        alternativas: alternativas
      }

      dispatch(crearEjercicio(nuevoEjercicio));
      setOpen(false);
    }
  }

  return (
    <div className="p-3">
      <TextField
        sx={{mb: 1}}
        autoFocus
        margin="dense"
        id="name"
        label="Enunciado del Ejercicio"
        multiline
        rows={10}
        fullWidth
        variant="outlined"
        value={enunciado}
        onChange={(e: any) => setEnunciado(e.target.value)}
        autoComplete="off"
      />

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('A')}>
          {
            letra === 'A' ? 
            <RadioButtonCheckedIcon color='primary'/> : 
            <RadioButtonUncheckedIcon color='primary'/>
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          multiline={true}
          placeholder="Alternativa (A)"
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'A'), { alternativa: e.target.value, letra: 'A', estado: (letra === 'A' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('B')}>
          {
            letra === 'B' ? 
            <RadioButtonCheckedIcon color='primary'/> : 
            <RadioButtonUncheckedIcon color='primary'/>
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          multiline={true}
          placeholder="Alternativa (B)"
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'B'), { alternativa: e.target.value, letra: 'B', estado: (letra === 'B' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('C')}>
          {
            letra === 'C' ? 
            <RadioButtonCheckedIcon color='primary'/> : 
            <RadioButtonUncheckedIcon color='primary'/>
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Alternativa (C)"
          autoComplete="off"
          multiline={true}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'C'), { alternativa: e.target.value, letra: 'C', estado: (letra === 'C' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('D')}>
          {
            letra === 'D' ? 
            <RadioButtonCheckedIcon color='primary'/> : 
            <RadioButtonUncheckedIcon color='primary'/>
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          placeholder="Alternativa (D)"
          multiline={true}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'D'), { alternativa: e.target.value, letra: 'D', estado: (letra === 'D' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      {/* <Button onClick={() => setOpen(false)}>Cancelar</Button> */}
      <Button onClick={() => handleCrearEjercicio()}>Crear</Button>
    
    </div>
  );
}

export default FormularioCrearSM;


// import { useState } from 'react';

// import {  Button, FormGroup, TextField, Typography,  } from "@mui/material";
// import { withStyles } from "@mui/styles";


// import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
// import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

// const StyledTextField = withStyles({
//   root: {
//     "& fieldset": {
//       borderTopLeftRadius: 0,
//       borderBottomLeftRadius: 0,
//       borderTopRightRadius: 5,
//       borderBottomRightRadius: 5,
//     }
//   }
// })(TextField);

// const StyledButton = withStyles({
//   root: {
//     borderTopRightRadius: 0,
//     borderBottomRightRadius: 0,
//     borderTopLeftRadius: 5,
//     borderBottomLeftRadius: 5,
//     textTransform: "lowercase",
//     // height: 37.5,
//     backgroundColor: '#F0F0F0',
//     border: 'solid 1px #D3D3D3',
//     '&:hover': {
//       background: "#E0E0E0",
//    },

//   }
// })(Button);

// type Props = {}

// const FormularioCrearSM = (props: Props) => {

//   const [alternativa, setAlternativa] = useState('a')

//   return (
//     <div className="p-4">

// <FormGroup row>
// <StyledButton variant="contained" disableElevation>
//         @example.com
//       </StyledButton>
//       <StyledTextField 
//       InputProps={{
//         startAdornment: 
//         <StyledButton variant="contained" disableElevation>
//         @example.com
//       </StyledButton>
//         ,
//       }}
//       variant="outlined" placeholder="username" />
      
//     </FormGroup>

//       <Typography variant="h6" className="mb-2">Crear Ejercicio</Typography>

//       <TextField
//         autoFocus
//         margin="dense"
//         id="name"
//         label="Enunciado del Ejercicio"
//         // type="email"
//         multiline
//         rows={10}
//         fullWidth
//         variant="outlined"
//         // value={enunciado}
//         // onChange={(e: any) => setEnunciado(e.target.value)}
//         autoComplete="off"
//       />

// <StyledButton variant="contained" disableElevation onClick={() => setAlternativa('a')}>
//   {alternativa === 'a' ? <RadioButtonCheckedIcon color='primary'/> : <RadioButtonUncheckedIcon color='primary'/>}
// </StyledButton>
// <StyledTextField label="Alternativa (a)" id="alternativa-a" size="small"/>
      
//       <table >
//         <tbody>
//           <tr>
//             <td style={{padding: 0, margin: 0}} className="py-2">
//               <StyledButton variant="contained" disableElevation onClick={() => setAlternativa('a')}>
//                 {alternativa === 'a' ? <RadioButtonCheckedIcon color='primary'/> : <RadioButtonUncheckedIcon color='primary'/>}
//               </StyledButton>
//             </td>
//             <td style={{padding: 0, margin: 0, width: '100%'}}>
//               <StyledTextField fullWidth label="Alternativa (a)" id="alternativa-a" size="small"/>
//             </td>
//           </tr>
//           <tr>
//             <td style={{padding: 0, margin: 0}} className="py-2">
//               <StyledButton variant="contained" disableElevation onClick={() => setAlternativa('b')}>
//                 {alternativa === 'b' ? <RadioButtonCheckedIcon color='primary'/> : <RadioButtonUncheckedIcon color='primary'/>}
//               </StyledButton>
//             </td>
//             <td style={{padding: 0, margin: 0, width: '100%'}}>
//               <StyledTextField fullWidth label="Alternativa (b)" id="alternativa-b" size="small"/>
//             </td>
//           </tr>
//           <tr>
//             <td style={{padding: 0, margin: 0}} className="py-2">
//               <StyledButton variant="contained" disableElevation onClick={() => setAlternativa('c')}>
//                 {alternativa === 'c' ? <RadioButtonCheckedIcon color='primary'/> : <RadioButtonUncheckedIcon color='primary'/>}
//               </StyledButton>
//             </td>
//             <td style={{padding: 0, margin: 0, width: '100%'}}>
//               <StyledTextField fullWidth label="Alternativa (c)" id="alternativa-c" size="small"/>
//             </td>
//           </tr>
//           <tr>
//             <td style={{padding: 0, margin: 0}} className="py-2">
//               <StyledButton variant="contained" disableElevation onClick={() => setAlternativa('d')}>
//                 {alternativa === 'd' ? <RadioButtonCheckedIcon color='primary'/> : <RadioButtonUncheckedIcon color='primary'/>}
//               </StyledButton>
//             </td>
//             <td style={{padding: 0, margin: 0, width: '100%'}}>
//               <StyledTextField fullWidth label="Alternativa (d)" id="alternativa-d" size="small"/>
//             </td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   )
// }

// export default FormularioCrearSM